import { SpaceBetween, FormField, Select } from '@amzn/awsui-components-react';
import { OptionDefinition } from '@amzn/awsui-components-react/polaris/internal/components/option/interfaces';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { OptionalLabel } from './Common';
import { EventInput, Visibility } from '@amzn/red-velvet-api';

export interface VisibilityComponentProps {
  currentFields: EventInput;
  updateFieldHandler: (fields: EventInput) => void;
  isReadOnly?: boolean;
}

export function VisibilityComponent(props: VisibilityComponentProps) {
  const namespaces = ['events', 'translation'];
  const { t } = useTranslation(namespaces);

  const visibilityOption: Record<string, OptionDefinition> = {
    PUBLIC: { label: t('visibility.public'), value: Visibility.PUBLIC },
    PRIVATE_DIRECT_LINK: { label: t('visibility.private'), value: Visibility.PRIVATE_DIRECT_LINK },
  };

  const [visibilityField, setVisibility] = useState(
    props.currentFields.visibility
      ? visibilityOption[props.currentFields.visibility]
      : visibilityOption.PUBLIC
  );

  return (
    <FormField
      label={
        <SpaceBetween direction="horizontal" size="l">
          <OptionalLabel>{t('eventDetailsStep.visibility')}</OptionalLabel>
        </SpaceBetween>
      }
      description={t('eventDetailsStep.visibilitySubText')}
    >
      <Select
        selectedOption={visibilityField}
        onChange={(event) => {
          setVisibility(event.detail.selectedOption);
          props.updateFieldHandler({
            ...props.currentFields,
            visibility: event.detail.selectedOption.value as Visibility,
          });
        }}
        options={[visibilityOption.PUBLIC, visibilityOption.PRIVATE_DIRECT_LINK]}
        readOnly={props.isReadOnly}
      />
    </FormField>
  );
}
